<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th>{{ $t("warehouse.货架编号") }}</th>
            <th>{{ $t("warehouse.货架名称") }}</th>
            <th>{{ $t("warehouse.仓位前缀") }}</th>
            <th class="tx-center">{{ $t("warehouse.库存总数量") }}</th>
            <th class="tx-center">{{ $t("warehouse.列") }}</th>
            <th class="tx-center">{{ $t("warehouse.层") }}</th>
            <th class="tx-center">{{ $t("warehouse.已生成仓位数量") }}</th>
            <th class="tx-center">{{ $t("warehouse.状态") }}</th>
            <th class="wd-150">{{ $t("warehouse.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="valign-middle">
              <a
                class="tx-info"
                href="javascript:;"
                @click="openEditShelf(2, item)"
                >{{ item.id }}</a
              >
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{ item.name }}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{ item.prefix }}</span>
            </td>
            <td class="valign-middle tx-center">
              <span class="tx-white">{{ item.totalCnt }}</span>
            </td>
            <td class="valign-middle tx-center">
              <span class="tx-white">{{ item.column }}</span>
            </td>
            <td class="valign-middle tx-center">
              <span class="tx-white">{{ item.row }}</span>
            </td>
            <td class="valign-middle tx-center">
              <span class="tx-white">{{ item.positionCnt }}</span>
            </td>
            <td class="valign-middle tx-center">
              <span :class="{ 'tx-white': item.status == 1 }">{{
                $t($dict.shelfStatus[item.status])
              }}</span>
            </td>
            <td>
              <div v-if="isSysRights('Warehouse.listPosition')">
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="openPositionListEmpty(item)"
                  >{{ $t("warehouse.空闲仓位查询") }}</a
                >
              </div>
              <div v-if="isSysRights('PrintLabel.printPositionLabel')">
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="openPrintLabel(item)"
                  >{{ $t("warehouse.打印仓位条码") }}</a
                >
              </div>
              <div v-if="isSysRights('Warehouse.changeShelf')">
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="openEditShelf(2, item)"
                  >{{ $t("warehouse.查看与编辑") }}</a
                >
              </div>
              <div class="d-flex align-items-center">
                <a
                  v-if="
                    item.name != $t('warehouse.默认货架') &&
                    isSysRights('Warehouse.changeShelfStatus')
                  "
                  :class="item.status == 1 ? 'tx-danger' : 'tx-info'"
                  class="mg-r-15"
                  href="javascript:;"
                  @click="changeShelfStatus(item)"
                  >{{
                    item.status == 1
                      ? $t("warehouse.停用")
                      : $t("warehouse.启用")
                  }}</a
                >
                <a
                  v-if="
                    item.name != $t('warehouse.默认货架') &&
                    isSysRights('Warehouse.deleteShelf')
                  "
                  class="tx-info"
                  href="javascript:;"
                  @click="openDeleteShelf(item)"
                  >{{ $t("warehouse.删除") }}</a
                >
              </div>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="9">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i
                >{{ $t("warehouse.没有符合条件的货架") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  methods: {
    openPrintLabel(item) {
      this.$emit("openPrintLabel", item);
    },
    openEditShelf(type, item) {
      this.$emit("openEditShelf", type, item);
    },
    changeShelfStatus(item) {
      this.$emit("changeShelfStatus", item);
    },
    openDeleteShelf(item) {
      this.$emit("openDeleteShelf", item);
    },
    openPositionListEmpty(item) {
      this.$emit("openPositionListEmpty", item);
    },
  },
};
</script>